<script lang="ts">
  import IntegratedTooltipIcon from "@shared/svelte/Components/IntegratedTooltipIcon.svelte";

  import type { Distributor } from "@shared/types/Distributor";

  export let distributor: Pick<
    Distributor,
    "name" | "integrated" | "seven_fifty_integration" | "uses_price_zones"
  >;

  const isIntegrated =
    distributor?.integrated ||
    (distributor?.seven_fifty_integration && distributor?.uses_price_zones);

</script>

{#if distributor?.name}
  <div data-testid="distributor-name" class="fizz-flex-row-4" style="align-items: start;">
    {#if isIntegrated}
      <div class="fizz-relative" style="top: 0.25rem">
        <IntegratedTooltipIcon {distributor} />
      </div>
    {/if}
    <div
      class="fizz-text-medium fizz-text-subdued fizz-text-left"
      data-testid="product-card-distributor-name"
    >
      {distributor.name}
    </div>
  </div>
{/if}
